import axiosIns from '../../../xaxios';
import { obtenerUrlAPIPagos } from '../utils/funciones';

export default {
  async create(data) {
    return await axiosIns.post(obtenerUrlAPIPagos('solicitudes-pagos-padres'), data);
  },
  async findAll(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('solicitudes-pagos-padres'), { params: opciones.params });
  },
  async findOne(id) {
    return await axiosIns.get(obtenerUrlAPIPagos(`solicitudes-pagos-padres/${id}`));
  },
  async findAllPaginado(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('solicitudes-pagos-padres/paginado'), { params: opciones.params });
  },
  async update(id, data) {
    return await axiosIns.patch(obtenerUrlAPIPagos(`solicitudes-pagos-padres/${id}`), data);
  },
};
